import errorIcon from "assets/images/error-icon.svg";
import classNames from "classnames";
import React, {useLayoutEffect, useRef, useState} from "react";

import DateInput, {DateString} from "components/DateInput";

import styles from "./StyledDateInput.module.css";

type Props = {
  className?: string;
  value: DateString;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeDate?: (date: DateString) => void;
  label: string;
  errorText?: string;
} & Omit<
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >,
  "type"
>;

export default function StyledDateInput({
  className,
  value,
  onChange,
  onChangeDate,
  label,
  errorText,
  ...rest
}: Props) {
  const errorRef = useRef<HTMLSpanElement>(null);
  const [errorWidth, setErrorWidth] = useState(0);
  useLayoutEffect(() => {
    if (errorRef.current) {
      setErrorWidth(errorRef.current.offsetWidth);
    }
  }, [value, errorText]);

  return (
    <div className={classNames(styles.container, className)}>
      <DateInput
        className={styles.input}
        value={value}
        style={{paddingRight: errorText ? errorWidth + 18 : 16}}
        onChange={(event) => {
          onChange?.(event);
          onChangeDate?.(event.target.value as DateString);
        }}
        {...rest}
      />
      <label className={styles.label}>{label}</label>
      {errorText && (
        <span
          onLoad={() => {
            if (errorRef.current) {
              setErrorWidth(errorRef.current.offsetWidth);
            }
          }}
          ref={errorRef}
          className={styles.errorTextContainer}
        >
          <span className={styles.errorText}>{errorText}</span>
          <img alt="" src={errorIcon} />
        </span>
      )}
    </div>
  );
}
